import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { FaPlus } from 'react-icons/fa'

import ActivityItem from '../ActivityItem'

import Activity from '../../../../services/Activity'

import './styles.css'

function Main() {
  const [activities, setActivities] = useState([])
  const [refresh, setRefresh] = useState(true)

  const forceRefresh = () => {
    setRefresh(true)
  }

  useEffect(() => {
    if (refresh) {
      Activity.read()
        .then(res => {
          setActivities(res)
          setRefresh(false)
        })
    }
  }, [refresh])

  return (
    <div id="main-section">
      <div className="title-content-main">
        <h3 className='title-activitity'>Atividades</h3>
      </div>
      <div className="scroll-content-main">
        <ul className="activitys-list">
          {activities.map(activity => (
            <ActivityItem
              id={activity.id}
              title={activity.title}
              description={activity.description}
              link={activity.link}
              handleDelete={forceRefresh}
              key={activity.id}
            />
          ))}
        </ul>
      </div>
      <Link to='/admin/activity/new' className="icon-add-main" >
        <FaPlus />
      </Link>
    </div>
  )
}

export default Main